export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Surveying Educator — Bristol, United Kingdom',
    'My students finally understand the difference between bearings, azimuths and coordinate calculations. I used to waste hours searching for the right way to explain how surveys are conducted. Now I enter the classroom fully prepared.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Topography Instructor — Dublin, Ireland',
    'I never arrive unprepared anymore. I know exactly how to explain leveling procedures or how to use total stations and GNSS receivers. This resource does the heavy lifting for me.',
  ],
  [
    'NC',
    'Nora C.',
    'Civil Engineering Teacher — Munich, Germany',
    'The lesson planning saves me countless hours. The integrated surveying projects are organized step-by-step. I never improvise in front of my students anymore.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Surveying Educator | Bristol, United Kingdom',
    "The material on traverse calculations and coordinate systems completely changed how my students understand positioning. They finally grasp how surveyors determine exact locations. It's the clearest resource I've found. I use it from day one and it captures their attention immediately.",
  ],
  [
    'JW',
    'Jennifer W.',
    'Topography Instructor | Dublin, Ireland',
    'The 150 activities alone are worth the price. I never improvise a lesson anymore. I finish every quarter knowing everything is prepared and ready.',
  ],
  [
    'TM',
    'Thomas M.',
    'Civil Engineering Teacher | Berlin, Germany',
    "The 50 surveying projects transformed how my students see surveying applications. Now they conduct actual field surveys, calculate positions and create topographic maps, and they understand why surveying knowledge matters. I haven't found this quality in any other resource.",
  ],
  [
    'EH',
    'Elizabeth H.',
    'University Lecturer | Oxford, United Kingdom',
    'The surveying reference handbook gave me back my class time. I used to spend twenty minutes explaining how to calculate bearing conversions. Now I show the handbook and students instantly understand surveying calculations.',
  ],
  [
    'MS',
    'Martin S.',
    'Surveying Instructor | Copenhagen, Denmark',
    "The assessment bank and project ideas were eye-opening. My students finally understand why all this matters. They're surveying local land, setting construction stakes and analyzing terrain. This completely transformed how they see surveying.",
  ],
];
